import { Component, computed, OnDestroy, OnInit, signal, TemplateRef, ViewChild, inject } from "@angular/core";
import { ApiService } from "src/app/services/api/api.service";
import { IonicModule, Platform, ToastController } from "@ionic/angular";
import { LicenseService } from "src/app/services/api/license.service";
import { TranslateModule } from "@ngx-translate/core";
import { LanguageSwitcherComponent } from "src/app/components/language-switcher/language-switcher.component";
import { CommonModule } from "@angular/common";
import { PreferencesService } from "src/app/services/preferences/preferences-service.service";
import { App } from '@capacitor/app';
import { NetworkserviceService } from "src/app/services/Networkservice/networkservice.service";
import { Browser } from '@capacitor/browser';
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { ThermalInfo, ThermalService } from "src/app/services/thermal/thermal.service";

@Component({
	selector: "app-information",
	templateUrl: "./information.page.html",
	styleUrls: ["./information.page.scss"],
	imports: [IonicModule, TranslateModule, LanguageSwitcherComponent, CommonModule],
})
export class InformationPage implements OnInit, OnDestroy {
	private apiService = inject(ApiService);
	private licenseService = inject(LicenseService);
	private storage = inject(PreferencesService);
	private network = inject(NetworkserviceService);
	private modalState = inject(ModalStateService);
	private thermalService = inject(ThermalService);

	public appVersionNumber: string | number;
	public IPADRESS = signal<string>(""); 
	public hwid = toSignal(this.apiService.getUniqueDeviceId(), { initialValue: '' });
	public licenseNumber = computed(() => this.licenseService.license()?.licenseNumber);
	public serialNumber = this.apiService.serialNumber;
	public thermal = signal<ThermalInfo | null>(null);
	public thermalLoading = signal<boolean>(true);
	public maxCpuTemp = computed(() => this.thermalService.maxCpuTemp(this.thermal()));
	public peaks = computed(() => this.thermal()?.peaks ?? null);
	private thermalInterval: any;
	@ViewChild('headerTemplate', { static: true }) headerTemplate: TemplateRef<void>;
	@ViewChild('footerTemplate', { static: true }) footerTemplate: TemplateRef<void>;

	async ngOnInit() {
		this.modalState.setHeaderTemplate(this.headerTemplate);
		this.modalState.setFooterTemplate(this.footerTemplate);
		await this.getIP();

		this.appVersionNumber = (await App.getInfo()).version

		this.storage.get("serialNo").then((result) => {});

		await this.refreshThermal();
		this.thermalInterval = setInterval(() => this.refreshThermal(), 3000);
	}

	ngOnDestroy() {
		if (this.thermalInterval) {
			clearInterval(this.thermalInterval);
			this.thermalInterval = null;
		}
	}

	async refreshThermal() {
		try {
			this.thermal.set(await this.thermalService.getThermalInfo());
		} finally {
			this.thermalLoading.set(false);
		}
	}

	async resetThermalPeaks() {
		await this.thermalService.resetPeaks();
		await this.refreshThermal();
	}

	async getIP() {
		this.IPADRESS.set(await this.network.getLocalIPAddress())
		
	}

	openBrowser(url: string) {
		Browser.open({url});
	}

	dismissModal() {
		this.modalState.triggerDismiss();
	}
}
